import TableComponent from './Table';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TableCell from './TableCell';
import TableBody from './TableBody';
import TableSelectedItem from './TableSelectedItem';
import TableInterestBars from './TableInterestBars';

type TableComposition = typeof TableComponent & {
  Header: typeof TableHeader;
  Row: typeof TableRow;
  Cell: typeof TableCell;
  Body: typeof TableBody;
  SelectedItem: typeof TableSelectedItem;
  InterestBars: typeof TableInterestBars;
};

export default TableComponent;
export const Table: TableComposition = TableComponent as TableComposition;

// Subclasses //
Table.Header = TableHeader;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Body = TableBody;
Table.SelectedItem = TableSelectedItem;
Table.InterestBars = TableInterestBars;
